import { render, staticRenderFns } from "./InspectToAwardForm.vue?vue&type=template&id=15fe7727&scoped=true"
import script from "./InspectToAwardForm.vue?vue&type=script&setup=true&lang=js"
export * from "./InspectToAwardForm.vue?vue&type=script&setup=true&lang=js"
import style0 from "./InspectToAwardForm.vue?vue&type=style&index=0&id=15fe7727&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fe7727",
  null
  
)

export default component.exports